import { Component } from '@verndale/core';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { keyCode } from '../helpers';

gsap.registerPlugin(ScrollTrigger);

class Module extends Component {
  setupDefaults() {
    this.dom = {
      videoTrigger: this.el.querySelector(
        '.s-curve-card__media--video .s-curve-card__media-container'
      ),
      localVideo: this.el.querySelector('.s-curve-card__media--video video'),
      vimeoVideo: this.el.querySelector(
        '.s-curve-card__media--video [data-vimeo-id]'
      )
    };

    if (this.dom.vimeoVideo) {
      this.vimeoPlayer = new Vimeo.Player(this.dom.vimeoVideo, {
        controls: false
      });
    }

    this.initShapeAnimation();
  }

  addListeners() {
    if (this.dom.videoTrigger) {
      this.dom.videoTrigger.addEventListener(
        'click',
        this.handleVideoClick.bind(this)
      );
      this.dom.videoTrigger.addEventListener('keypress', e => {
        const key = e.which || e.keyCode;

        if (key === keyCode.RETURN || key === keyCode.SPACE) {
          e.preventDefault();
          this.handleVideoClick(this);
        }
      });
    }

    if (this.dom.localVideo) {
      this.dom.localVideo.addEventListener(
        'play',
        this.handleVideoPlay.bind(this)
      );
      this.dom.localVideo.addEventListener(
        'pause',
        this.handleVideoPause.bind(this)
      );
      this.dom.localVideo.addEventListener(
        'ended',
        this.handleVideoEnd.bind(this)
      );
    }
  }

  async handleVideoClick() {
    let isPlaying;

    if (this.dom.localVideo) {
      if (!this.dom.localVideo.playing) {
        this.dom.localVideo.play();
      }
    } else if (this.vimeoPlayer) {
      const url = encodeURI(this.vimeoPlayer.element.src);
      const params = new URLSearchParams(url.split('?')[1]);

      if (params.get('controls') === '0') {
        this.vimeoPlayerAddControls();
      } else {
        const isPaused = await this.vimeoPlayer.getPaused();
        isPlaying = !isPaused;

        if (isPlaying) {
          this.vimeoPlayer.pause();
        } else {
          this.vimeoPlayer.play();
        }
      }
    }
  }

  vimeoPlayerAddControls() {
    this.vimeoPlayer.destroy().then(() => {
      this.dom.videoTrigger.classList.add(
        's-curve-card__media--vimeo-initialized'
      );
      this.vimeoPlayer = new Vimeo.Player(this.dom.vimeoVideo, {
        controls: true
      });
      this.vimeoPlayer.play();
      this.vimeoPlayer.on('play', this.handleVideoPlay.bind(this));
      this.vimeoPlayer.on('pause', this.handleVideoPause.bind(this));
      this.vimeoPlayer.on('ended', this.handleVideoEnd.bind(this));
    });
  }

  handleVideoPlay() {
    this.dom.videoTrigger.classList.add('s-curve-card__media--video-triggered');
    this.dom.localVideo &&
      this.dom.localVideo.setAttribute('controls', 'controls');
  }

  handleVideoPause() {
    this.dom.videoTrigger.classList.remove(
      's-curve-card__media--video-triggered'
    );
    this.dom.localVideo &&
      this.dom.localVideo.removeAttribute('controls', 'controls');
  }

  handleVideoEnd() {
    this.dom.videoTrigger.classList.remove(
      's-curve-card__media--video-triggered'
    );

    if (this.dom.localVideo) {
      this.dom.localVideo.currentTime = 0;
      this.dom.localVideo.load();
      this.dom.localVideo.removeAttribute('controls', 'controls');
    }
  }
}

export default Module;
